import { createSlice } from '@reduxjs/toolkit';

export const adminDashboard = createSlice({
  name: 'dashboard',
  initialState: {
    selectedModel: [],
    selectedRating: [],
    selectedEmail: [],
    selectedFont: [],
    selectedDateRange: {
      startDate: null,
      endDate: null,
    },
    includeMyTeam: false,
    externalUsers: false,

    // all user history data
    historyData: [],
    loadingHistory: false,
    historyError: false,
    currentPage: 1,
    previousPage: 1,
    pageSize: 50,
    totalDocuments: 0,
    totalPages: 0,

    // analytics data
    overAllRating: [],
    overAllRatingResult: [],
    feedbackComments: [],
    feedback1Rating: [],
    feedback2Rating: [],
    feedback3Rating: [],
    analyticsLoading: false,
    analyticsError: null,
  },
  reducers: {
    selectModel: (state, action) => {
      state.selectedModel = action.payload;
    },
    selectRating: (state, action) => {
      state.selectedRating = action.payload;
    },
    selectEmail: (state, action) => {
      state.selectedEmail = action.payload;
    },
    selectFont: (state, action) => {
      state.selectedFont = action.payload;
    },
    setDateRange: (state, action) => {
      const { startDate, endDate } = action.payload;
    
      state.selectedDateRange = {
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
      };
    }, 
    setIncludeMyTeam: (state) => {
      state.includeMyTeam = !state.includeMyTeam;
      state.externalUsers = false;
      state.selectedEmail = [];
    },
    setExternalUsers: (state) => {
      state.externalUsers = !state.externalUsers;
      state.includeMyTeam = false
      state.selectedEmail = [];
    },
    resetFilters: (state) => {
      state.selectedModel = [];
      state.selectedEmail = [];
      state.selectedFont = [];
      state.selectedRating = [];
      state.selectedDateRange = { startDate: null, endDate: null };
      state.includeMyTeam = false
      state.externalUsers = false;
    },

    // all users history reducers
    setHistoryLoading: (state, action) => {
      state.loadingHistory = action.payload;
    },

    setHistoryData: (state, action) => {
      state.historyData = [...state.historyData, ...action.payload.hsitoryData];
      state.totalDocuments = action.payload.totalDocuments;
      state.totalPages = action.payload.totalPages;
      state.currentPage = Number(action.payload.currentPage);
      state.previousPage = state.currentPage - 1;
      state.loadingHistory = false;
      state.historyError = false;
    },
    setEmptyHistoryData: (state) => {
      state.historyData = [];
    },
    setHistoryError: (state, action) => {
      state.historyError = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    // analytics reducers
    setOverAllRating: (state, action) => {
      state.overAllRating = action.payload;
      state.analyticsLoading = false;
    },
    setOverAllRatingResult: (state, action) => {
      state.overAllRatingResult = action.payload;
    },
    setFeedbackComments: (state, action) => {
      state.feedbackComments = action.payload;
    },
    setFeedback1Rating: (state, action) => {
      state.feedback1Rating = action.payload;
    },
    setFeedback2Rating: (state, action) => {
      state.feedback2Rating = action.payload;
    },
    setFeedback3Rating: (state, action) => {
      state.feedback3Rating = action.payload;
    },
    setAnalyticsLoading: (state, action) => {
      state.analyticsLoading = action.payload;
    },
    setAnalyticsError: (state, action) => {
      state.analyticsError = action.payload;
    },
  },
});

export const {
  selectModel,
  selectRating,
  selectEmail,
  selectFont,
  setDateRange,
  setIncludeMyTeam,
  setExternalUsers,
  resetFilters,
  setHistoryData,
  setEmptyHistoryData,
  setHistoryLoading,
  setHistoryError,
  setCurrentPage,
  setOverAllRating,
  setOverAllRatingResult,
  setFeedbackComments,
  setFeedback1Rating,
  setFeedback2Rating,
  setFeedback3Rating,
  setAnalyticsLoading,
  setAnalyticsError,
} = adminDashboard.actions;

export default adminDashboard.reducer;
